/**
 * Formaty polskie: data DD.MM.RRRR, przecinek dziesiętny, złotówki.
 * Wszystko przez Intl — bez ręcznego sklejania, bo strefa czasowa i zmiana
 * czasu potrafią popsuć takie sklejanie dokładnie raz w roku.
 */
const STREFA = 'Europe/Warsaw';

const fmtData = new Intl.DateTimeFormat('pl-PL', {
  day: '2-digit', month: '2-digit', year: 'numeric', timeZone: STREFA,
});
const fmtDataGodzina = new Intl.DateTimeFormat('pl-PL', {
  day: '2-digit', month: '2-digit', year: 'numeric',
  hour: '2-digit', minute: '2-digit', timeZone: STREFA,
});
const fmtGodzina = new Intl.DateTimeFormat('pl-PL', {
  hour: '2-digit', minute: '2-digit', timeZone: STREFA,
});
const fmtZl = new Intl.NumberFormat('pl-PL', {
  style: 'currency', currency: 'PLN', minimumFractionDigits: 2,
});
const fmtIlosc = new Intl.NumberFormat('pl-PL', {
  minimumFractionDigits: 0, maximumFractionDigits: 3,
});

type Wejscie = string | number | Date | null | undefined;

function naDate(v: Wejscie): Date | null {
  if (v == null || v === '') return null;
  const d = v instanceof Date ? v : new Date(v);
  return Number.isNaN(d.getTime()) ? null : d;
}

export const data = (v: Wejscie) => { const d = naDate(v); return d ? fmtData.format(d) : '—'; };
export const dataGodzina = (v: Wejscie) => { const d = naDate(v); return d ? fmtDataGodzina.format(d) : '—'; };
export const godzina = (v: Wejscie) => { const d = naDate(v); return d ? fmtGodzina.format(d) : '—'; };
export const zlote = (v: number | string | null | undefined) =>
  v == null ? '—' : fmtZl.format(Number(v));
export const ilosc = (v: number | string | null | undefined) =>
  v == null ? '—' : fmtIlosc.format(Number(v));

/** „przed chwilą”, „14 min temu" — do dziennika i list odświeżanych na bieżąco. */
export function temu(v: Wejscie): string {
  const d = naDate(v);
  if (!d) return '—';
  const sek = Math.round((Date.now() - d.getTime()) / 1000);
  if (sek < 45) return 'przed chwilą';
  if (sek < 3600) return `${Math.round(sek / 60)} min temu`;
  if (sek < 86_400) return `${Math.round(sek / 3600)} godz. temu`;
  return dataGodzina(d);
}
